export enum AppWindowType {
  SETTINGS = 'settings',
  OVERLAY = 'overlay',
  ONBOARDING = 'onboarding',
  /** A popout showing one sidepanel View; many may be open, keyed by the View's identity. */
  VIEW = 'view',
}

/**
 * App window types that use the shared app.html + app.tsx entry point.
 * Main process loads `app.html` for these; overlay and others use their own HTML.
 */
export const APP_WINDOW_TYPES_WITH_SHARED_ENTRY: Array<AppWindowType> = [AppWindowType.SETTINGS, AppWindowType.VIEW]
